export enum modelNames {
  // system
  MODAL = 'modals',
  FORM = 'forms',
  AUTH_STATE = 'authState',
  OAUTH_SIGN_UP = 'oAuthSignUp',
  AUTO_DETECTED_COUNTRY = 'autoDetectedCountry',
  REOPEN_ACCOUNT = 'reopenAccount',

  // Domains
  SENT_SMS = 'sentSms',
  SENT_SMS_SHORT = 'sentSmsShort',
  SENT_SMS_FULL = 'sentSmsFull',
  BULK_SENT_SMS = 'bulkSentSms',
  RECEIVED_SMS = 'receivedSms',
  RECEIVED_SMS_COUNTER = 'receivedSmsCounter',
  BYOC = 'byoc',
  BYOC_PHONE = 'byocPhone',
  BYOC_CARRIER_PHONE = 'byocCarrierPhone',
  BYOC_PROVIDER_PHONE = 'byocProviderPhone',
  BYOC_SENDER_ID = 'byocSenderId',
  BYOC_CARRIER_SENDER_ID = 'byocCarrierSenderId',
  BYOC_PROVIDER_SENDER_ID = 'byocProviderSenderId',
  BYOC_CARRIER = 'byocCarrier',
  CONTACT = 'contacts',
  TAG_ANALYTICS = 'tagAnalytics',
  TAG = 'tag',
  LABEL = 'label',
  SCHEDULED_MESSAGE = 'scheduledMessage',
  SCHEDULED_SHORT_MESSAGE = 'scheduledShortMessage',
  SCHEDULED_MESSAGE_PARAMETERS = 'scheduledMessageParameters',
  SCHEDULED_NOT_SENT_MESSAGE = 'scheduledNotSentMessage',
  SCHEDULED_CAMPAIGN = 'ScheduledEmail',
  SCHEDULED_CAMPAIGN_FETCH = 'scheduledEmailFetch',
  SCHEDULED_CAMPAIGN_SINGLE_RECIPIENT = 'scheduledEmailSingleRecipient',
  SCHEDULED_CAMPAIGN_FAILED_FETCH = 'scheduledEmailFailedFetch',
  SCHEDULED_CAMPAIGN_SINGLE = 'scheduledEmailSingle',
  SCHEDULED_CAMPAIGN_RECIPIENTS = 'scheduledEmailRecipients',
  SCHEDULED_CALENDAR_EVENT = 'scheduledCalendarEvent',
  SCHEDULED_CALENDAR_EVENT_DETAILS = 'scheduledCalendarEventDetails',
  SCHEDULED_CONTACT_MESSAGE = 'scheduledContactMessage',
  AUDIT_LOG = 'auditLog',
  REPORTING_OVERVIEW = 'reportingOverview',
  REPORTING_EMAIL_OVERVIEW = 'reportingEmailOverview',
  REPORTING_EMAIL_AVAILABILITY = 'reportingEmailAvailability',
  REPORTING_EMAIL_TREND = 'reportingEmailTrend',
  REPORTING_EMAIL_SENDER = 'reportingEmailSender',
  REPORTING_EMAIL_LINK = 'reportingEmailLink',
  REPORTING_EMAIL_USER = 'reportingEmailUser',
  REPORTING_NUMBER = 'reportingNumber',
  REPORTING_SUBACCOUNT = 'reportingSubAccount',
  REPORTING_USER = 'reportingUser',
  REPORTING_CALL = 'reportingCall',
  REPORTING_MESSAGE = 'reportingMessage',
  BLOCKED_CONTACT = 'blockedContacts',
  PINNED_CONTACT = 'pinnedContacts',
  CONTACT_LIST = 'contactList',
  CONTACT_LIST_TEMP = 'contactListTemp',
  CONTACT_GROUPING_ITEM = 'contactGroupingItem',
  CONTACT_LIST_FOLDER = 'contactListFolder',
  CONTACT_LIST_FOLDER_SUMMARY = 'contactListFolderSummary',
  CONTACT_LIST_FOLDER_TREE_NODE = 'contactListFolderTreeNode',
  BULK_EMAIL_CAMPAIGN_CONTACT_LIST_TEMP = 'bulkEmailCampaignContactListTemp',
  CONTACT_IMPORT = 'contactImport',
  CONTACT_IMPORT_RESULT = 'contactImportResult',
  UNSUBSCRIBED_CONTACT = 'unsubscribedContact',
  UNSUBSCRIBED_EMAIL_CONTACT = 'unsubscribedEmailContact',
  UNSUBSCRIBED_SETTINGS = 'unsubscribedSettings',
  TEMPLATE = 'template',
  EMAIL_TEMPLATE = 'emailTemplate',
  TEMPLATE_CATEGORY = 'templateCategory',
  SIP_CALL = 'sipCall',
  INBOUND_CALL = 'inboundCall',
  OUTBOUND_CALL = 'outboundCall',
  FORWARDED_CALL = 'forwardedCall',
  FORWARD_AUDIO = 'forwardAudio',
  SENDER_SOURCE = 'senderSource',

  // session
  SESSION = 'session',
  SESSION_SHORT = 'sessionShort',
  SESSION_STAT = 'sessionStat',
  SMS_SESSION_RECIPIENTS = 'smsSessionRecipients',

  ALLOWED_EMAIL = 'allowedEmail',
  ACCOUNT_NOTIFICATIONS_SETTINGS = 'accountNotificationsSettings',
  SEND_RECEIVE_SETTINGS = 'sendReceiveSettings',
  SMS_SURVEY = 'smsSurvey',
  SMS_SURVEY_NODES_TREE = 'smsSurveyNodesTree',
  SMS_SURVEY_DETAILS = 'smsSurveyDetails',
  SMS_SURVEY_NODE = 'smsSurveyNode',
  SMS_SURVEY_NODE_WITH_CHILDREN = 'smsSurveyNodeWithChildren',
  SMS_SURVEY_NODE_WITH_ROWS = 'smsSurveyNodeWithRows',
  SMS_SURVEY_REPLY = 'smsSurveyReply',
  SMS_SURVEY_RECIPIENT_COUNTRY = 'smsSurveyRecipientCountry',
  FORM_CLICK_TO_TEXT = 'formClickToText',
  FORM_CLICK_TO_TEXT_DETAILS = 'formClickToTextDetails',
  FORM_SUBSCRIBE = 'formSubscribe',
  FORM_SUBSCRIBE_DETAILS = 'formSubscribeDetails',
  MESSAGES_PRICE = 'messagesPrice',
  MESSAGES_PRICE_FOR_COUNTRY = 'MessagesPriceForCountry',
  MESSAGES_PREVIEW = 'messagesPreview',
  MESSAGES_PREVIEW_RECIPIENT = 'messagesPreviewRecipient',
  MESSAGES_BULKS_PROGRESS = 'messagesBulksProgress',
  MESSAGES_ATTACHMENT_FILE = 'messagesAttachmentFile',
  RECENT_RECIPIENT = 'recentRecipient',
  CUSTOM_FIELD_SCHEMA = 'customFieldSchema',
  CONTACT_CUSTOM_FIELD_ORDER = 'contactCustomFieldOrder',
  CUSTOM_FIELD_VALUE = 'customFieldValue',
  USER_ANALYTICS_FIELD = 'userAnalyticsField',
  USER_ANALYTICS_TRAIT = 'userAnalyticsTrait',
  USER_PRESENCE = 'userPresence',
  USER_NUMBERS = 'userNumbers',
  PHONE_NUMBER = 'phoneNumber',
  AVAILABLE_TO_BUY_NUMBERS = 'availableToBuyNumbers',
  NUMBER_AVAILABLE_COUNTRY = 'numberAvailableCountry',
  AREA_CODES = 'areaCodes',
  ACCOUNT_SETTINGS_SECURITY = 'accountSettingsSecurity',
  NUMBER_PRICE = 'numberPrice',
  CHAT_SETTINGS = 'chatSettings',
  CHAT = 'chat',
  CHAT_PAGE_INFO = 'chatPageInfo',
  CHAT_MESSAGE = 'chatMessage',
  CHAT_MESSAGE_THREAD = 'chatMessageThread',
  CHAT_MESSAGE_CONTENT = 'chatMessageContent',
  CHAT_MMS_INFO = 'chatMmsInfo',
  CHAT_DETAILS = 'chatDetails',
  TYPING = 'typing',
  ALSO_HERE = 'alsoHere',
  CHAT_EXTRA_FILTERS = 'chatExtraFilters',
  CHAT_STATISTICS = 'chatStatistics',
  CHAT_CONVERSATION_SENDER_SETTINGS = 'chatConversationSenderSettings',
  CHAT_PREVIEW_NEXT = 'chatPreviewNext',
  WIDGET_CHAT_CENTRIFUGE_TOKEN = 'widgetChatCentrifugeToken',
  WHATSAPPACCOUNT = 'whatsAppAccount',
  WHATSAPPBUSINESSPHONE = 'whatsAppBusinessPhone',
  WHATSAPPCONFIG = 'whatsAppConfig',
  WHATSAPPACTIVITY = 'whatsAppActivity',
  FACEBOOK_CONFIG = 'facebookConfig',
  FACEBOOK_PAGE = 'facebookPage',
  INSTAGRAM_ACCOUNT = 'instagramAccount',
  VOICE_CALL_CONFIG = 'voiceCallConfig',
  BILLING_DETAILS = 'billingDetails',
  CARRIER_LOOKUP = 'carrierLookup',
  CARRIER_LOOKUP_SESSION = 'carrierLookupSession',
  EMAIL_LOOKUP = 'emailLookup',
  ACCOUNT_SSO_SETTINGS = 'accountSsoSettings',
  POINT_AI_ASSISTANT = 'pointAiAssistant',
  POINT_AI_WEBSITE = 'pointAiWebsite',
  POINT_AI_WEBSITE_DOWNLOADED = 'pointAiWebsiteDownloaded',
  DISTRIBUTION = 'distribution',
  DISTRIBUTION_DETAILS = 'distributionDetails',
  API_V2_ENTRY = 'apiV2Entry',
  API_V1_SETTINGS = 'apiV1Settings',
  API_V2_SETTINGS = 'apiV2Settings',
  BILLING = 'billing',
  BILLING_PLAN_INFO = 'billingPlanInfo',
  AUTOMATION_RULE = 'automationRule',
  AUTOMATION_RULE_DETAILS = 'automationRuleDetails',
  AUTOMATION_RULE_LOGS = 'automationRuleLogs',
  AUTOMATION_RULE_LOGS_SHORT = 'automationRuleLogsShort',
  AUTOMATION_RULE_ACTION = 'automationRuleAction',
  TEN_DLC_PHONE_NUMBER = 'tenDlcPhoneNumber',
  TEN_DLC_CAMPAIGN = 'tenDlcCampaign',
  TOLL_FREE_BRAND = 'tollFreeBrand',
  TEN_DLC_TWILIO_BRAND = 'tenDlcTwilioBrand',
  WIZARD = 'wizard',
  STATEMENT = 'statement',
  STATEMENT_SUMMARY = 'statementsSummary',
  ATTACHMENT_FILE = 'attachmentFile',
  PROGRESS = 'progress',
  UNDO_REDO_HISTORY = 'undoRedoHistory',
  DELETED_ENTITY = 'deletedEntity',

  ACTIVITY_CALL = 'activityCall',
  ACTIVITY_LIVE_CHAT = 'activityLiveChat',
  ACTIVITY_FACEBOOK = 'activityFacebook',
  ACTIVITY_INSTAGRAM = 'activityInstagram',
  ACTIVITY_EMAIL_CAMPAIGN = 'activityEmailCampaign',

  /* to avoid circular references:
  Contact -> Organization -> Contact (primaryContact)
  */
  // to avoid circular references:
  // Contact -> Phone -> Unsubscribers -> Contact
  // Contact -> Email -> Unsubscribers -> Contact
  // Actually it`s looks like:
  // Contact -> Phone -> UnsubscriberChannel (reference to Contact is not exists)
  // Contact -> Email -> UnsubscriberChannel (reference to Contact is not exists)
  EXPORT_FILE = 'exportFile',
  BASE_WRAPPER = 'baseWrapper',
  USER = 'users',
  USER_PERSONAL_INFO = 'userPersonalInfo',
  USER_SETTINGS = 'userSettings',
  MARKETING_DATA = 'marketingData',
  NOTE = 'notes',
  NOTE_FEED_ITEM = 'noteFeedItems',
  NOTE_FEED_STATS = 'noteFeedStats',
  NOTES_SCOPE = 'notesScope',
  TIMEZONE = 'timezone',
  COUNTRY = 'country',
  UNAUTHENTICATED_COUNTRY = 'unauthenticatedCountry',
  PRELOAD = 'preload',
  PAGE_MAP_PRELOAD = 'pageMapPreload',
  SENDER_ID = 'senderId',
  SENDER_ID_PRICE = 'senderIdPrice',
  SUB_ACCOUNT_IMPORT_SESSION = 'subAccountImportSession',
  USER_SESSION = 'userSession',

  MY_DATA_COUNTERS = 'myDataCounters',

  // subaccounts import
  SUBACCOUNTS_IMPORT = 'subAccountsImport',
  SUBACCOUNTS_IMPORT_DETAILS = 'subAccountsImportDetails',
  SUB_ACCOUNT_PERMISSIONS = 'subAccountPermissions',
  TEAM_WORKFLOW = 'teamWorkflow',
  CENTRIFUGE = 'Centrifuge',

  // counters
  SENT_SMS_COUNTER = 'sentSmsCounter',
  DELIVERED_SMS_COUNTER = 'deliveredSmsCounter',
  FAILED_SMS_COUNTER = 'failedSmsCounter',
  REJECTED_SMS_COUNTER = 'rejectedSmsCounter',
  BULK_SENT_SMS_COUNTER = 'bulkSentSmsCounter',
  CONTACT_COUNTER = 'contactCounter',
  LIST_CONTACTS_COUNTER = 'listContactsCounter',

  // sender settings: countries
  SENDER_SETTINGS_COUNTRY = 'SenderSettingsCountry',

  // fields
  BASE_FIELD = 'baseField',
  FIELD = 'field',
  FIELD_ARRAY = 'fieldArray',
  FIELD_GROUP = 'FieldGroup',
  FIELD_MULTI_ENTITY = 'FieldMultiEntity',

  // billing
  INVOICE = 'invoices',

  // table
  ALL_SELECTED_TABLES = 'allSelectedTables',
  FILTERS_SCHEMA = 'filtersSchema',
  COLUMNS = 'columns',
  SELECTED_ROWS = 'selectedRows',
  TABLE = 'tables',
  TABLE_RECOVERY_DATA = 'tableRecoveryData',
  TABLE_PAGE_STATE = 'tablePageState',
  SORTER = 'sorters',
  GROUPING = 'grouping',
  PAGINATION = 'paginations',
  CURSOR_PAGINATION_PAGE = 'cursorPaginationPage',
  SEARCH = 'search',
  COUNTER = 'counter',
  VIEWER = 'viewer',

  // facets
  FACETS = 'facets',

  // UI
  AUTOCOMPLETE = 'autocomplete',
  ORDER = 'order',
  VISIBILITY = 'visibility',
  COMPOSE_LOCAL = 'composeLocal',
  GLOBAL_STATE = 'globalState',
  MEDIA_DEVICE = 'MediaDevice',
  UI_STATE = 'uiState',
  PRIMARY_BROWSER_TAB = 'primaryBrowserTab',
  PRIMARY_BROWSER_TAB_LOCK = 'primaryBrowserTabLock',

  // FOR FUNCTIONAL TESTS PURPOSE
  TEST = 'tests',
  SINGLE_TEST = 'singleTests',
  WITH_RELATION_TEST = 'withRelationTests',
  RELATION_TEST = 'relationTests',
  CHILD_TEST = 'childTests',
  COUNTER_TEST = 'counterTest',
  BRACKET_NOTATION_TEST = 'bracketNotationTests',

  LOGIN_HISTORY = 'loginHistory',
  KEYWORD = 'keyword',
  EMAIL_LOOKUP_SESSION = 'emailLookupSession',
  TEN_DLC_REQUEST = 'tenDlcRequest',
  TEN_DLC_PRICING = 'tenDlcPricing',
  TOLL_FREE_REQUEST = 'tollFreeRequest',
  TOLL_FREE_PRE_FILL_DATA = 'tollFreePreFillData',
  TEN_DLC_PRE_FILL_DATA = 'tenDlcPreFillData',
  TOLL_FREE_PHONE_NUMBER = 'tollFreePhoneNumber',
  TOLL_FREE_COMPLIANCE_CHECK = 'tollFreeComplianceCheck',
  TEN_DLC_COMPLIANCE_CHECK = 'tenDlcComplianceCheck',
  REGULATIONS_STATUS = 'regulationsStatus',
  GETTING_STARTED_INFO = 'gettingStartedInfo',
  UI_SETTINGS = 'uiSettings',

  USER_TRIAL = 'userTrial',

  NAVIGATION_ORDER = 'navigationOrder',

  TASK = 'task',
  TASK_STAGE = 'taskStage',
  TASK_BOARD = 'taskBoard',
  TASK_BOARD_ARCHIVED = 'taskBoardArchived',
  TASK_CHECKLIST = 'taskChecklist',
  TASK_CHECKLIST_ITEM = 'taskChecklistItem',
  TASK_COMMENT = 'taskComment',

  EMAIL_UNSUBSCRIBE_DATA = 'emailUnsubscribeData',
  EMAIL_CAMPAIGN_UNSUBSCRIBE_PAGE_DATA = 'emailCampaignUnsubscribePageData',

  NPS_SURVEY = 'npsSurvey',

  // Messages Settings
  WEB_WIDGET = 'webWidget',
  WEB_WIDGET_DETAILS = 'webWidgetDetails',

  // Stripe billing
  STRIPE_PAYG_PRICE = 'stripePaygPrice',
  STRIPE_MONTHLY_PLAN_PRICE = 'stripeMonthlyPlanPrice',
  STRIPE_PAYMENT_METHOD = 'stripePaymentMethod',

  // Tickets
  TICKET = 'ticket',
  TICKET_STATUS = 'ticketStatus',
  TICKET_INBOX = 'ticketInbox',
  TICKET_MESSAGE = 'ticketMessage',
  TICKET_FIRST_LAST_MESSAGE = 'ticketFirstLastMessage',
  TICKET_COUNT = 'ticketCount',
  TICKET_MESSAGE_TRIMMED_CONTENT = 'ticketMessageTrimmedContent',
  TICKET_MESSAGE_CONTENT = 'ticketMessageContent',
  TICKET_WORKSPACE = 'ticketWorkspace',
  TICKET_SPAM_FILTER = 'ticketSpamFilter',

  // Filtered views
  FILTERED_VIEW = 'filteredView',
  SEGMENT = 'segment',
  FILTERED_VIEW_FOR_ENTITY = 'filteredViewForEntity',

  // Deals
  DEAL_PIPELINE = 'dealPipeline',
  DEAL_PIPELINE_ARCHIVED = 'dealPipelineArchived',
  DEAL_STAGE = 'dealStage',
  DEAL = 'deal',
  DEAL_TIMELINE_ITEM = 'deaTimelineItem',
  DEAL_ACTIVITY = 'dealActivity',
  DEAL_ACTIVITY_ITEM = 'dealActivityItem',

  // Campaigns
  EMAIL_CAMPAIGN = 'emailCampaign',
  EMAIL_CAMPAIGN_RECIPIENTS = 'emailCampaignRecipients',
  EMAIL_CAMPAIGN_MESSAGE = 'emailCampaignMessage',
  EMAIL_CAMPAIGN_OPEN = 'emailCampaignOpen',
  EMAIL_CAMPAIGN_UNSUBSCRIBE = 'emailCampaignUnsubscribe',
  EMAIL_CAMPAIGN_CLICK_SUMMARY = 'emailCampaignClickSummary',
  EMAIL_CAMPAIGN_CLICK_SUMMARY_STATISTICS = 'emailCampaignClickSummaryStatistics',
  EMAIL_CAMPAIGN_SPAM_REPORT = 'emailCampaignSpamReport',
  EMAIL_CAMPAIGN_CLICK = 'emailCampaignClick',
  EMAIL_CAMPAIGN_DOMAIN = 'emailCampaignDomain',
  EMAIL_CAMPAIGN_EMAIL_SENDER = 'emailCampaignEmailSender',
  EMAIL_CAMPAIGN_SETTINGS = 'emailCampaignSettings',
  EMAIL_CAMPAIGN_DOMAIN_ENTRI_TOKEN = 'emailCampaignDomainEntriToken',
  EMAIL_CAMPAIGN_DOMAIN_ENTRI_TOKEN_SELL = 'emailCampaignDomainEntriTokenSell',

  OUTBOUND_EMAIL_DETAILS = 'OutboundEmailDetails',

  // Follow up
  FOLLOW_UP = 'FollowUp',
  FOLLOW_UP_DETAILS = 'FollowUpDetails',

  // Compose email
  COMPOSE_EMAIL = 'composeEmail',
  COMPOSE_EMAIL_PREVIEW = 'composeEmailPreview',
  COMPOSE_EMAIL_PREVIEW_MESSAGE = 'composeEmailPreviewMessage',
  COMPOSE_EMAIL_PREVIEW_MESSAGES = 'composeEmailPreviewMessages',
  COMPOSE_EMAIL_FREQUENTLY_SENT = 'composeEmailFrequentlySent',

  RECIPIENT_CONTACT = 'recipientContact',
  RECIPIENT_GROUP = 'recipientGroup',
  RECIPIENT_FILTERED_VIEW = 'recipientFilteredView',

  // Stripo
  STRIPO_TOKEN = 'stripoToken',
  STRIPO_TEMPLATE_TYPE = 'stripoTemplateType',
  STRIPO_TEMPLATE_FEATURE = 'stripoTemplateFeature',
  STRIPO_TEMPLATE_INDUSTRY = 'stripoTemplateIndustry',
  STRIPO_TEMPLATE_SEASON = 'stripoTemplateSeason',
  STRIPO_PREBUILT_TEMPLATE = 'stripoPrebuiltTemplate',

  // Automation
  AUTOMATION_FLOW = 'automationFlow',
  AUTOMATION_FLOW_STEP = 'automationFlowStep',
  AUTOMATION_LOG = 'automationLog',
  AUTOMATION_LOG_PREVIEW = 'automationLogPreview',
  AUTOMATION_LOG_STEP = 'automationLogStep',
  AUTOMATION_FLOW_VALIDATION_RESULT = 'automationFlowValidationResult',
  AUTOMATION_FLOW_STEP_STATISTICS = 'automationFlowStepStatistics',
  AUTOMATION_TEMPLATE = 'automationTemplate',
  AUTOMATION_TEMPLATE_PLACEHOLDER = 'automationTemplatePlaceholder',
  AUTOMATION_FLOW_AI_CONVERSATION = 'automationFlowAiConversation',
  AUTOMATION_FLOW_AI_CONVERSATION_MESSAGE = 'automationFlowAiConversationMessage',
  AUTOMATION_FLOW_AI_AVAILABILITY = 'automationFlowAiAvailability',
  AUTOMATION_FLOW_AI_PROMPT_SUGGESTION = 'automationFlowAiPromptSuggestion',
  AUTOMATION_FLOW_AI_BUILDER_STATE = 'automationFlowAiBuilderState',

  BONUS_INFO = 'bonusInfo',

  EXTERNAL_INTEGRATION = 'externalIntegration',
  EXTERNAL_INTEGRATION_CUSTOMER = 'externalIntegrationCustomer',

  SHOPIFY_EXTERNAL_INTEGRATION = 'shopifyExternalIntegration',
  WOO_COMMERCE_EXTERNAL_INTEGRATION = 'wooCommerceExternalIntegration',
  HUBSPOT_EXTERNAL_INTEGRATION = 'hubspotExternalIntegration',
  ZOHO_EXTERNAL_INTEGRATION = 'zohoExternalIntegration',

  CONSENT_APP = 'consentApp',
  CONNECTED_APP = 'connectedApp',
}

export const STI_TYPE_KEY = 'eff8680e-0424-45d5-85b5-f2e113ee3f64'
